import { Component, OnInit } from '@angular/core'
import { Classification } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { BaseCountry } from '../../../models/enum/country.enum'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { SharedService } from '../../../services/shared/shared.service'

@Component({
    selector: 'app-product-delivery-tab',
    templateUrl: './product-delivery-tab.component.html',
    styleUrls: ['./product-delivery-tab.component.scss'],
    standalone: false
})
export class ProductDeliveryTabComponent implements OnInit {
  product$: Observable<ICustomProduct>

  // product$: Observable<ICustomProduct> = this.currentProductService.getProduct();
  // vimal

  pallet: string

  constructor(
    protected currentProductService: CurrentProductService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct()
    this.pallet = 'aupallet'
    if (this.sharedService.baseSiteId == BaseCountry.NZ) {
      this.pallet = 'nzpallet'
    }
  }

  public filterClassifications(classification: Classification): boolean {
    if (
      classification.code === 'consumerUnits' ||
      classification.code === 'transportUnits' ||
      classification.code === this.pallet
    ) {
      return false
    } else {
      return true
    }
  }
}
